
export const valueFromList = (me: any, listKey: string, key: string) => {
 return (item: any) => {
   const list = me[listKey];
   return list[item[key]] || item[key];
 };
}

export const listFromMap = (map: Record<string, string>) => {
  const items: {value: string; label: string}[] = [];

  for (const key of Object.keys(map)) {
    items.push({value: key, label: map[key]});
  }

  return items;

}

export const mapFromList = (list: {value: string; label: string}[]) => {
  const result: Record<string, string> = {};

  for (const row of list) {
    result[row.value] = row.label;
  }

  return result;
}
